import numeral from 'numeral';
import { useStore } from '../../store';

export const FeatureExtraCost: React.FC<{ featureId: string }> = props => {
  const featureExtraCost = useStore(s => s.featureExtraCost(props.featureId));

  return <span>{numeral(featureExtraCost).format('$ 0,0.00')}</span>;
};
